/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Langkey1Inputs */

const en__field_langkey1 = /** @type {(inputs: _Field_Langkey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language key`)
};

const de__field_langkey1 = /** @type {(inputs: _Field_Langkey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprach Key`)
};

/**
* | output |
* | --- |
* | "Language key" |
*
* @param {_Field_Langkey1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_langkey1 = /** @type {((inputs?: _Field_Langkey1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Langkey1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_langkey1(inputs)
	return de__field_langkey1(inputs)
});
export { _field_langkey1 as "_field_langKey" }